import { render, staticRenderFns } from "./WithoutActiveSchools.vue?vue&type=template&id=374cde30&scoped=true&lang=pug&"
import script from "./WithoutActiveSchools.vue?vue&type=script&lang=js&"
export * from "./WithoutActiveSchools.vue?vue&type=script&lang=js&"
import style0 from "./WithoutActiveSchools.vue?vue&type=style&index=0&id=374cde30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374cde30",
  null
  
)

export default component.exports